import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "31",
  height: "30",
  fill: "none",
  viewBox: "0 0 31 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M6.75 13.752h14.825l-4.537-5.45a1.251 1.251 0 1 1 1.924-1.6l6.25 7.5q.064.09.113.187c0 .063 0 .1.088.163.056.143.086.296.087.45a1.3 1.3 0 0 1-.087.45c0 .062 0 .1-.088.162q-.049.098-.113.188l-6.25 7.5a1.25 1.25 0 0 1-.962.45 1.25 1.25 0 0 1-.962-2.05l4.537-5.45H6.75a1.25 1.25 0 1 1 0-2.5"
    }, null, -1)
  ])))
}
export default { render: render }